/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContractCategoryRate = 'Undefined' | 'ElectricitySmallConsumptionHousehold' | 'ElectricitySmallConsumptionConsumer' | 'ElectricityLargeConsumptionConsumer' | 'ElectricityVeryLargeConsumptionConsumer' | 'GasConsumptionHousehold' | 'GasConsumptionConsumer' | 'GasMiddleConsumptionConsumer' | 'GasLargeConsumptionConsumer' | 'HeatConsumptionHousehold' | 'HeatConsumptionConsumer';

export const ContractCategoryRate = {
    Undefined: 'Undefined' as ContractCategoryRate,
    ElectricitySmallConsumptionHousehold: 'ElectricitySmallConsumptionHousehold' as ContractCategoryRate,
    ElectricitySmallConsumptionConsumer: 'ElectricitySmallConsumptionConsumer' as ContractCategoryRate,
    ElectricityLargeConsumptionConsumer: 'ElectricityLargeConsumptionConsumer' as ContractCategoryRate,
    ElectricityVeryLargeConsumptionConsumer: 'ElectricityVeryLargeConsumptionConsumer' as ContractCategoryRate,
    GasConsumptionHousehold: 'GasConsumptionHousehold' as ContractCategoryRate,
    GasConsumptionConsumer: 'GasConsumptionConsumer' as ContractCategoryRate,
    GasMiddleConsumptionConsumer: 'GasMiddleConsumptionConsumer' as ContractCategoryRate,
    GasLargeConsumptionConsumer: 'GasLargeConsumptionConsumer' as ContractCategoryRate,
    HeatConsumptionHousehold: 'HeatConsumptionHousehold' as ContractCategoryRate,
    HeatConsumptionConsumer: 'HeatConsumptionConsumer' as ContractCategoryRate
};